/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AttachmentMetadata } from './AttachmentMetadata'

/**
 * Describes the operations to execute with this update.
 */
export class BulkAttachmentUpdateOptions {
  constructor(json: JSON | any) {
    Object.assign(this as BulkAttachmentUpdateOptions, json)
  }

  /**
   * Metadata for new attachments or attachments which will be updated, by key. The key for the main attachment is the document id.
   */
  updateAttachmentsMetadata?: { [key: string]: AttachmentMetadata }
  /**
   * Keys of attachments to delete. The key for the main attachment is the document id.
   */
  deleteAttachments?: Array<string>
}
